import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink, useLocation } from "react-router-dom";

function handleClick(event) {
  event.preventDefault();
}



function LinkRouter(props) {
  return <Link {...props} component={RouterLink} />;
}

export default function TrexoBreadCrumb() {

  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const categoryName = location.state?.categoryName;

  const breadcrumbNameMap = {
    // '/dashboard' : 'Home',
    '/qc': 'QC',
    '/qc/file-upload': 'File Upload',
    '/qc/archives': "Archives",

    '/drm': 'DRM',
    '/drm/audit-result': "Audit Result",
    '/drm/file-upload': "File Upload",
    '/drm/file-upload/files': "Upload Status",
    '/drm/archive': "Archive",
    '/drm/activity-code': "Activity Code",

    '/ids': "IDS",
    '/ids/ids-ref': "File Upload",

    '/oa': 'OA',
    '/oa/received': "All Office Actions",
    '/task-manager': 'Task Manager',
    '/task-manager/oa-workflow': "OA Shell",
    '/task-manager/post-grant-workflow': "Post Grant",

    '/docgen': "Docgen",
    '/docgen/drafts': "My Drafts",
    '/docgen/filing': "Ready for Filing",
    '/docgen/ack-awaited': "Ack.Awaited",
    '/docgen/favourites': "Favourites",
    '/docgen/matters': "Docket",
    '/docgen/forms': "Forms",
    '/docgen/custom-form': "Custom Forms",
    '/docgen/categories': "Category",
    "/docgen/categories/form": categoryName,
    '/docgen/import': "Import Docket",
    '/docgen/analytics-dashboard': "Analytics",

    '/collaboration-space': 'Collaboration Space',
    '/collaboration-space/my-files': "My Files",
    '/collaboration-space/shared': "Shared",
    '/collaboration-space/workspace': "Workspace",
    '/collaboration-space/reference-downloader': "References Retrieval Queue",
    '/collaboration-space/371-filing-package': "371 Filing Package",
    '/collaboration-space/oa-workflow': "OA Shell",
    '/collaboration-space/oa-workflow/tasks': "All OA Tasks",
    '/collaboration-space/oa-workflow/intake': "Upload Intake",
    '/collaboration-space/oa-workflow/batches': "Validation Result",

    '/collaboration-space/pgs-workflow': "Post Grant Support",
    '/collaboration-space/pgs-workflow/tasks': "All PGS Tasks",
    '/collaboration-space/pgs-workflow/upload': "Upload Intake",
    '/collaboration-space/pgs-workflow/validation-results': "Validation Result",


    '/file-number-generator': "File Number Generator",
    '/file-number-generator/my-list': "My List",
    '/file-number-generator/admin': "Admin",

    '/trexo-chat': "June",
    // '/june' : "June",
    '/trexo-chat/help': "Help",

    '/trademark-search': "TM Knockout Search",
    '/trademark-search/:id': "Trademark Details",

    '/data-verification': "Data Verification",

    '/kot': "Keep On Top",
    '/kot/active-clients': "Active Clients",
    '/kot/favorites': "Favorites",
    '/kot/track-changes': "Track Changes",
    "/kot/client/new": "Add Client",
    "/kot/client/edit": "Client Details",
    "/kot/inactive-clients": "Inactive Clients",
    "/kot/reports/inventor-details": "Reports",
    "/kot/reports/licensing-summary": "Reports",
    "/kot/reports/entity-status": "Reports",

    '/adim' : "ADIM",
    '/adim/process-matter': "Process Matter",
    '/adim/track-task': "Track Task"

  };

  return (
    <Stack spacing={2} sx={{
      display: {
        xs: 'none',
        sm: 'block'
      }
    }}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <LinkRouter underline="hover" color="inherit" to="/dashboard">
          Home
        </LinkRouter>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          let label = breadcrumbNameMap[to] || value;

          if (to.startsWith('/trademark-search/')) {
            label = breadcrumbNameMap['/trademark-search/:id'];
          }

          if (label === 'OA') return null;
          if (to === "/kot/client") return null;

          if (!breadcrumbNameMap[to]) return null;

          const hasNextMapped = pathnames
            .slice(index + 1)
            .some((_, i) => {
              const nextTo = `/${pathnames.slice(0, index + 2 + i).join('/')}`;
              return breadcrumbNameMap[nextTo];
            });

          const last = !hasNextMapped;

          return last ? (
            <Typography color="text.primary" key={to}>
              {label}

            </Typography>
          ) : (
            <LinkRouter underline="hover" color="inherit" to={to} key={to}>
              {label}
            </LinkRouter>
          );
        })}
      </Breadcrumbs>

    </Stack>
  );
}